<template>
  <div id="app" class="center">
    <h1 class="day">
      {{ day }}
    </h1>
    <p class="timeOfDay">
      {{ timeOfDay }}
    </p>
    <p class="time">
      {{ time }}
    </p>
    <p class="date">
      {{ date }}
    </p>
    <div v-if="false" class="buttons">
      <button v-if="!_state" @click="resume">Resume</button>
      <button v-if="_state" @click="pause">Pause</button>
    </div>
  </div>
</template>

<script>
import ResourceBlockDisplay from "@/mixins/resourceBlocks/Display";
import MemoryCard from "./card";
//add to credits: https://codepen.io/Vpugh/pen/MVpaxo
export default {
  name: "Display_MatchGame",
  mixins: [ResourceBlockDisplay],
  components: {
    MemoryCard
  },
  created () {
    this.pollTime()
  },
  mounted() {
    let _vm = this;
    this.interval = setInterval(
        _vm.updateCurrentTime,
        1000
    );
  },
  computed: {
    time() {
      return this.hours + ":" + this.minutes + ":" + this.seconds;
    },
    milliseconds: function() {
      return this.currentTime;
    },
    hours: function() {
      var milli = this.milliseconds;
      // Doing the math
      // var hrs = Math.floor((milli / 3600000) % 24);
      // Using getHours()
      var hrs = new Date().getHours();
      if (hrs >= 13) {
        hrs = hrs - 12;
      }
      return hrs >= 10 ? hrs : "0" + hrs;
    },
    minutes() {
      var milli = this.milliseconds;
      var min = Math.floor((milli / 60000) % 60);
      return min >= 10 ? min : "0" + min;
    },
    seconds() {
      var milli = this.milliseconds;
      var sec = Math.ceil((milli % 60000) / 1000).toFixed(0);
      //if (sec == 60) { sec = 00 }
      return sec >= 10 ? sec : "0" + sec;
    },
    day() {
      return "TUESDAY";
    },
    timeOfDay() {
      return "Morning";
    },
    date() {
      return "September  26 2023";
    }
  },
  beforeDestroy () {
    clearInterval(this.polling)
  },
  methods: {
    reset() {
      this._state = true;
      this.currentTime = Date.now();
    },
    pause() {
      this._state = false;
    },
    resume() {
      this._state = true;
    },
    updateCurrentTime() {
      if (this._state == true) {
        this.currentTime = Date.now();
      }
    },
    pollTime () {
      let that = this;
      this.polling = setInterval(() => {
        //this.$store.dispatch('RETRIEVE_DATA_FROM_BACKEND');
        //console.log('Running');
        that.currentTime = Date.now();
      }, 1000)
    }
  },
  data() {
    return {
      polling: null,
      /* Overrides */
      assetsURLHome: "/assets/apps/matchgame/",
      /* App Specific */
      _state: true,
      currentTime: Date.now(),
      interval: null
    };
  }
};
</script>

<style lang="scss" scoped>
.day h2 {
  color: #ffffff;
  font-size: 1em;
  width: 100%;
  // display: block;
  text-align: center;
  container-name: sidebar;
}
.module h2 {
  font-size: 1em;
  container-name: sidebar;
}

@container sidebar (min-width: 700px) {
  .module h2 {
    font-size: 2em;
  }
}
.timeOfDay {
  color: #ffffff;
  font-size: 140px;
  text-align: center;
}
.time {
  color: #ffffff;
  font-size: 200px;
  // width: 100%;
  // display: block;
  text-align: center;
}
.date {
  color: #ffffff;
  font-size: 90px;
  text-align: center;
}
.buttons {
  // display: block;
  // width: 100%;
  text-align: center;
  position: absolute;
  bottom: 30%;
  button {
    background-color: darkblue;
    border: none;
    padding: 14px 34px 10px 34px;
    text-transform: uppercase;
    color: #fff;
    font-weight: bold;
    letter-spacing: 4px;
  }
}
</style>
